function Swipe (g, model) {
  var swipe = this;

  swipe.DIRECTION_UP = 1;
  swipe.DIRECTION_DOWN = 2;
  swipe.DIRECTION_LEFT = 4;
  swipe.DIRECTION_RIGHT = 8;
  swipe.DIRECTION_UP_RIGHT = 16;
  swipe.DIRECTION_UP_LEFT = 32;
  swipe.DIRECTION_DOWN_RIGHT = 64;
  swipe.DIRECTION_DOWN_LEFT = 128;

  swipe.g = g;
  swipe.model = model !== undefined ? model : null;
  // swipe.dragLength = 100;
  swipe.dragLength = 50;
  swipe.diagonalDelta = 50;
  swipe.swiping = false;
  swipe.direction = null;
  swipe.tmpDirection = null;
  swipe.tmpCallback = null;
  swipe.diagonalDisabled = true;

  // this.g.input.onDown.add(function () {
  //   swipe.swiping = true;
  // });
  // this.g.input.onUp.add(function () {
  //   swipe.swiping = false;
  // })
  this.g.input.on('pointerdown', function () {
    swipe.swiping = true;
  });
  this.g.input.on('pointerup', function () {
    swipe.swiping = true;
  });

  this.setupKeyboard();
}

Swipe.prototype.setupKeyboard = function () {
  var swipe = this;
  // var up = this.g.input.keyboard.addKey(Phaser.Keyboard.UP);
  this.g.input.keyboard.on('keydown_UP', function () {
    if (swipe.tmpDirection !== null) {
      switch (swipe.tmpDirection) {
        case swipe.DIRECTION_LEFT:
          swipe.direction = swipe.DIRECTION_UP_LEFT;
          swipe.model !== null && swipe.model.upLeft && swipe.model.upLeft();
          break;
        case swipe.DIRECTION_RIGHT:
          swipe.direction = swipe.DIRECTION_UP_RIGHT;
          swipe.model !== null && swipe.model.upRight && swipe.model.upRight();
          break;
        default:
          swipe.direction = swipe.DIRECTION_UP;
          swipe.model !== null && swipe.model.up && swipe.model.up();
      }
      swipe.tmpDirection = null;
      swipe.tmpCallback = null;
    } else {
      swipe.tmpDirection = swipe.DIRECTION_UP;
      swipe.tmpCallback = swipe.model !== null && swipe.model.up ? swipe.model.up : null;
    }
  });
  this.g.input.keyboard.on('keyup_UP', this.keyUp, this);

  // var down = this.g.input.keyboard.addKey(Phaser.Keyboard.DOWN);
  this.g.input.keyboard.on('keydown_DOWN', function () {
    if (swipe.tmpDirection !== null) {
      switch (swipe.tmpDirection) {
        case swipe.DIRECTION_LEFT:
          swipe.direction = swipe.DIRECTION_DOWN_LEFT;
          swipe.model !== null && swipe.model.downLeft && swipe.model.downLeft();
          break;
        case swipe.DIRECTION_RIGHT:
          swipe.direction = swipe.DIRECTION_DOWN_RIGHT;
          swipe.model !== null && swipe.model.downRight && swipe.model.downRight();
          break;
        default:
          swipe.direction = swipe.DIRECTION_DOWN;
          swipe.model !== null && swipe.model.down && swipe.model.down();
      }
      swipe.tmpDirection = null;
      swipe.tmpCallback = null;
    } else {
      swipe.tmpDirection = swipe.DIRECTION_DOWN;
      swipe.tmpCallback = swipe.model !== null && swipe.model.down ? swipe.model.down : null;
    }
  });
  this.g.input.keyboard.on('keyup_DOWN', this.keyUp, this);

  // var left = this.g.input.keyboard.addKey(Phaser.Keyboard.LEFT);
  this.g.input.keyboard.on('keydown_LEFT', function () {
    if (swipe.tmpDirection !== null) {
      switch (swipe.tmpDirection) {
        case swipe.DIRECTION_UP:
          swipe.direction = swipe.DIRECTION_UP_LEFT;
          swipe.model !== null && swipe.model.upLeft && swipe.model.upLeft();
          break;
        case swipe.DIRECTION_DOWN:
          swipe.direction = swipe.DIRECTION_DOWN_LEFT;
          swipe.model !== null && swipe.model.downLeft && swipe.model.downLeft();
          break;
        default:
          swipe.direction = swipe.DIRECTION_LEFT;
          swipe.model !== null && swipe.model.left && swipe.model.left();
      }
      swipe.tmpDirection = null;
      swipe.tmpCallback = null;
    } else {
      swipe.tmpDirection = swipe.DIRECTION_LEFT;
      swipe.tmpCallback = swipe.model !== null && swipe.model.left ? swipe.model.left : null;
    }
  });
  this.g.input.keyboard.on('keyup_LEFT', this.keyUp, this);
  // var right = this.g.input.keyboard.addKey(Phaser.Keyboard.RIGHT);
  this.g.input.keyboard.on('keydown_RIGHT', function () {
    if (swipe.tmpDirection !== null) {
      switch (swipe.tmpDirection) {
        case swipe.DIRECTION_UP:
          swipe.direction = swipe.DIRECTION_UP_RIGHT;
          swipe.model !== null && swipe.model.upRight && swipe.model.upRight();
          break;
        case swipe.DIRECTION_DOWN:
          swipe.direction = swipe.DIRECTION_DOWN_RIGHT;
          swipe.model !== null && swipe.model.downRight && swipe.model.downRight();
          break;
        default:
          swipe.direction = swipe.DIRECTION_RIGHT;
          swipe.model !== null && swipe.model.right && swipe.model.right();
      }
      swipe.tmpDirection = null;
      swipe.tmpCallback = null;
    } else {
      swipe.tmpDirection = swipe.DIRECTION_RIGHT;
      swipe.tmpCallback = swipe.model !== null && swipe.model.right ? swipe.model.right : null;
    }
  });
  this.g.input.keyboard.on('keyup_RIGHT', this.keyUp, this);
};

Swipe.prototype.keyUp = function () {
  this.direction = this.tmpDirection;
  this.tmpDirection = null;
  if (this.tmpCallback !== null) {
    this.tmpCallback.call(this.model);
    this.tmpCallback = null;
  }
}

Swipe.prototype.check = function () {
  if (this.direction !== null) {
    let result = { x: 0, y: 0, direction: this.direction };
    this.direction = null;
    return result;
  }
  if (!this.swiping) return null;

  // if (Phaser.Point.distance(this.g.input.activePointer.position, this.g.input.activePointer.positionDown) < this.dragLength) return null;
  if (this.g.input.activePointer.getDistance() < this.dragLength) return null;

  this.swiping = false;

  var direction = null;
  // var deltaX = this.g.input.activePointer.position.x - this.g.input.activePointer.positionDown.x;
  // var deltaY = this.g.input.activePointer.position.y - this.g.input.activePointer.positionDown.y;
  var deltaX = this.g.input.activePointer.position.x - this.g.input.activePointer.downX;
  var deltaY = this.g.input.activePointer.position.y - this.g.input.activePointer.downY;

  let result = {
    // x: this.g.input.activePointer.positionDown.x,
    // y: this.g.input.activePointer.positionDown.y
    x: this.g.input.activePointer.downX,
    y: this.g.input.activePointer.downY
  };

  var deltaXabs = Math.abs(deltaX);
  var deltaYabs = Math.abs(deltaY);

  if (!this.diagonalDisabled && deltaXabs > (this.dragLength - this.diagonalDelta) && deltaYabs > (this.dragLength - this.diagonalDelta)) {
    if (deltaX > 0 && deltaY > 0) {
      direction = this.DIRECTION_DOWN_RIGHT;
      this.model !== null && this.model.downRight && this.model.downRight(result);
    } else if (deltaX > 0 && deltaY < 0) {
      direction = this.DIRECTION_UP_RIGHT;
      this.model !== null && this.model.upRight && this.model.upRight(result);
    } else if (deltaX < 0 && deltaY > 0) {
      direction = this.DIRECTION_DOWN_LEFT;
      this.model !== null && this.model.downLeft && this.model.downLeft(result);
    } else if (deltaX < 0 && deltaY < 0) {
      direction = this.DIRECTION_UP_LEFT;
      this.model !== null && this.model.upLeft && this.model.upLeft(result);
    }
  } else if (deltaXabs > this.dragLength || deltaYabs > this.dragLength) {
    if (deltaXabs > deltaYabs) {
      if (deltaX > 0) {
        direction = this.DIRECTION_RIGHT;
        this.model !== null && this.model.right && this.model.right(result);
      } else if (deltaX < 0) {
        direction = this.DIRECTION_LEFT;
        this.model !== null && this.model.left && this.model.left(result);
      }
    } else {
      if (deltaY > 0) {
        direction = this.DIRECTION_DOWN;
        this.model !== null && this.model.down && this.model.down(result);
      } else if (deltaY < 0) {
        direction = this.DIRECTION_UP;
        this.model !== null && this.model.up && this.model.up(result);
      }
    }
  }
  if (direction !== null) {
    result['direction'] = direction;
    return result;
  }
  return null;
};

export default Swipe;
